/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { type FinanceDashboard, financeDashboardApi } from '../api/finance-dashboard.js';

/** The finance dashboard read-model. Polls every 60s to stay close to real-time. */
export function useFinanceDashboard(): UseQueryResult<FinanceDashboard> {
  return useQuery({
    queryKey: ['finance', 'dashboard'],
    queryFn: () => financeDashboardApi.overview(),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
